"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageMarkdownRegex = exports.Image = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _core = require("@tiptap/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var imageMarkdownRegex = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?(?:\s+"([^"]+)"|\s+'([^']+)'|\s+(\S+))?\))$/;
exports.imageMarkdownRegex = imageMarkdownRegex;

var Image = _core.Node.create({
  name: 'image',
  group: 'inline',
  inline: true,
  draggable: false,
  addAttributes: function addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      },
      id: {
        default: null
      },
      title: {
        default: null
      }
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'img[src]'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;

    if (HTMLAttributes.alt === null) {
      HTMLAttributes = _objectSpread(_objectSpread({}, HTMLAttributes), {}, {
        'aria-hidden': true
      });
    }

    return ['img', HTMLAttributes];
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      setImage: function setImage(options) {
        return function (_ref2) {
          var commands = _ref2.commands;
          return commands.insertContent({
            type: _this.name,
            attrs: options
          });
        };
      }
    };
  },
  addInputRules: function addInputRules() {
    return [(0, _core.nodeInputRule)({
      find: imageMarkdownRegex,
      type: this.type,
      getAttributes: function getAttributes(match) {
        var _match = (0, _slicedToArray2.default)(match, 5),
            alt = _match[2],
            src = _match[3],
            title = _match[4];

        return {
          src: src,
          alt: alt,
          title: title
        };
      }
    })];
  }
});

exports.Image = Image;